import Echo from "laravel-echo";
// socket.io-client v4 — requires a socket.io v3/v4 server
// (see socket-server-v4/README-ADMIN.md). laravel-echo-server (v2) will NOT work.
import { io } from "socket.io-client";

export function createEcho(options) {
  return new Echo({
    broadcaster: "socket.io",
    client: io,
    ...options,
  });
}
